export default __webpack_public_path__ + "static/media/fingerprint-pdf2.b067db7f.png";